import { CalculationDataRequest, CookingDataResponse } from '@/entity/api-response'
import { Ingredients, IngredientGroups, Cooks, SearchSelect, UnitGrams, Menu } from '@/entity/entity'

function handleMasterData (raw : string[]) : Ingredients {
  const ingredients : Ingredients = {}
  raw.forEach((row) => {
    const arr = row.split(',')
    if (ingredients[arr[1]] === undefined) {
      ingredients[parseInt(arr[2], 10).toString()] = {
        name: arr[3],
        groupId: arr[0]
      }
    }
  })
  return ingredients
}

function handleAllMenuData (raw : string[], ingredients: Ingredients) : { ingredientGroups: IngredientGroups, cooks: Cooks } {
  const ingredientGroups : IngredientGroups = {}
  const cooks : Cooks = {}

  raw.forEach((row) => {
    const [cookId, cookName, ingredientId, ingredientName, origin, grams, energy, ingredientGroupName] = row.split(',')
    if (cooks[cookId] === undefined) {
      cooks[cookId] = {
        name: cookName,
        ingredients: [{
          id: parseInt(ingredientId, 10).toString(),
          name: ingredientName,
          origin: origin,
          consumption: parseInt(grams, 10),
          energy: parseInt(energy, 10)
        }]
      }
    } else {
      cooks[cookId].ingredients.push({
        id: parseInt(ingredientId, 10).toString(),
        name: ingredientName,
        origin: origin,
        consumption: parseInt(grams, 10),
        energy: parseInt(energy, 10)
      })
    }
    if (ingredients[ingredientId] !== undefined && ingredientGroups[ingredients[ingredientId].groupId] === undefined) {
      ingredientGroups[ingredients[ingredientId].groupId] = {
        name: ingredientGroupName.replace('\r\n', '')
      }
    }
  })

  return {
    ingredientGroups,
    cooks
  }
}

function handleSearchSelect (raw : { [key: string]: string[] }) : SearchSelect {
  const res : SearchSelect = {}
  for (const key in raw) {
    res[key] = raw[key].map(x => {
      const xArr = x.split(',')
      return {
        cookId: xArr[0],
        name: xArr[1]
      }
    })
  }
  return res
}

function handleUnitGrams (raw: string[]) : UnitGrams {
  const unitGrams : UnitGrams = {}
  raw.forEach(x => {
    const xArr = x.split(',')
    unitGrams[xArr[0]] = {
      name: xArr[1],
      value: parseInt(xArr[2], 10)
    }
  })
  return unitGrams
}

export function getData (raw : CookingDataResponse) : {
  cooks: Cooks,
  ingredients: Ingredients,
  ingredientGroups: IngredientGroups
  searchByIngredient: SearchSelect,
  searchByGenre: SearchSelect,
  searchByMethod: SearchSelect,
  unitGrams: UnitGrams
  } {
  const ingredients = handleMasterData([...raw.master_data])
  const res = handleAllMenuData([...raw.all_menu_data], ingredients)
  return {
    ingredients,
    cooks: res.cooks,
    ingredientGroups: ingredientGroup,
    searchByIngredient: handleSearchSelect(raw.search_food),
    searchByGenre: handleSearchSelect(raw.search_genre),
    searchByMethod: handleSearchSelect(raw.search_method),
    unitGrams: handleUnitGrams(raw.unit_grams)
  }
}

function getOriginCode (origin: string) : number {
  if (origin === '日本' || origin === '国産') return 0
  else if (origin === '日本以外' || origin === '外国産') return 1
  else return 2
}

export function convertMenuDataToRequestData (raw: Menu[]): CalculationDataRequest {
  const res : CalculationDataRequest = {
    menu_data: []
  }

  raw.forEach(function (menu) {
    res.menu_data.push({
      cooking_name: menu.name,
      materials: menu.ingredients.map(function (ingredient) {
        return {
          food_code: ingredient.id,
          producing_district: getOriginCode(ingredient.origin),
          amount_of_consumption: ingredient.grams.toString()
        }
      })
    })
  })

  return res
}

export const genre = {
  '001': '和食',
  '002': '中華料理',
  '003': 'アジア料理',
  '004': '西洋料理・洋食',
  '006': 'カレー',
  '007': '主食',
  '005': 'その他'
}

export const ingredientCategory = {
  '001': '肉',
  '002': '魚介類',
  '003': '米',
  '004': '野菜',
  '005': '豆腐・豆',
  '006': '小麦',
  '007': '海藻',
  '008': '卵',
  '009': '汁・スープ類',
  '010': '果物',
  '011': '牛乳・乳製品'
}

export const ingredientGroup = {
  '01': { name: '穀類' },
  '02': { name: 'いも・でんぷん類' },
  '04': { name: '豆類（豆類加工品を含む）' },
  '06': { name: '野菜・木の実' },
  '07': { name: 'くだもの' },
  '08': { name: 'きのこ' },
  '09': { name: '海藻類' },
  '10': { name: '魚介類' },
  '11': { name: '肉・たまご' },
  '13': { name: '牛乳・乳製品' },
  '14': { name: '油脂類' },
  '17': { name: '調味料' }
}

export const method = {
  '001': '煮る',
  '002': '炒める',
  '003': '焼く',
  '004': '炊く',
  '005': '蒸す',
  '006': '和える',
  '007': '揚げる',
  '008': '茹でる',
  '009': '漬ける'
}

export const originOptions = [
  { value: '不明', name: '不明' },
  { value: '国内製造', name: '国内製造' },
  { value: '国産', name: '国産' },
  { value: '外国産', name: '外国産 ' }
]
